import { useQuery } from "@tanstack/react-query";
import { partnerDashboardService } from "@/services/partner-dashboard-service";
import { resolvePartnerRevenue } from "../utils/partnerRevenueMetric";

const ALL_TIME_FROM = "2000-01-01T00:00:00.000Z";

/** All-time partner revenue of a tenant (EUR). A failed request gives null. */
export const useHotelPartnerRevenue = (tenantId: string | undefined) =>
  useQuery<number | null>({
    queryKey: ["hotels", "partner-revenue", tenantId || ""],
    enabled: Boolean(tenantId),
    queryFn: async () => {
      try {
        const summary = await partnerDashboardService.getTotalRevenue(
          tenantId!,
          { from: ALL_TIME_FROM, to: new Date().toISOString() },
        );
        return resolvePartnerRevenue(summary);
      } catch {
        return null;
      }
    },
    staleTime: 60 * 1000,
  });
